import { z } from "zod";

export const insolvencySchema = z.object({
  reason: z
    .string()
    .max(255, "La longitud máxima del motivo es de 255 caracteres")
    .optional()
    .or(z.literal("")),

  reference: z
    .string()
    .max(255, "La longitud máxima de la referencia es de 255 caracteres")
    .optional()
    .or(z.literal("")),

  code: z
    .string()
    .max(255, "La longitud máxima del código es de 255 caracteres")
    .optional()
    .or(z.literal("")),

  can_appeal: z.boolean(),

  payment_deadline_value: z
    .number({
      message: "Debe ingresar un número válido",
    })
    .min(0, "El número de días debe ser mayor o igual a 0"),

  payment_deadline_unit: z.enum(["HOURS", "DAYS", "WEEKS", "MONTHS"], {
    error: () => "Debe seleccionar una unidad válida",
  }),

  amount: z
    .number({
      message: "Debe ingresar un monto válido",
    })
    .min(1, "El monto debe ser mayor a 1"),

  comments: z
    .string()
    .max(1000, "La longitud máxima del comentario es de 1000 caracteres")
    .min(1, "El comentario no puede estar vacío"),

  insolvencyable_id: z
    .uuid("Debe ser un UUID válido")
    .min(1, "Debe seleccionar a quién asociar la infracción"),

  insolvencyable_type: z.enum(
    ["applicant", "property", "expedient_base_registry"],
    {
      error: () => "Debe seleccionar un tipo válido",
    },
  ),

  status: z
    .enum([
      "ACTIVE",
      "SOLVENT",
      "CANCELLED",
      "APPEAL_SUBMITTED",
      "APPEAL_REJECTED",
    ])
    .optional(),
});

export type InsolvencyFormData = z.output<typeof insolvencySchema>;

// Type for the API payload (only the fields that go to backend)
export type InsolvencyAPIPayload = {
  reason?: string;
  reference?: string;
  code?: string;
  can_appeal: boolean;
  payment_deadline_value: number;
  amount: number; // Sent as number to API
  insolvencyable_id: string;
  insolvencyable_type: "applicant" | "property" | "expedient_base_registry";
  status?:
    | "ACTIVE"
    | "SOLVENT"
    | "CANCELLED"
    | "APPEAL_SUBMITTED"
    | "APPEAL_REJECTED";
  comments?: string;
  payment_deadline_unit: "HOURS" | "DAYS" | "WEEKS" | "MONTHS";
};
